import axios from "axios";

const instance = axios.create({
  baseURL: "https://projectmarketplace-server.herokuapp.com/projectmarketplace/api/"
});

export default instance;